import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router';
import { SideMenu } from '@components/rep';
import { useAppDispatch } from '@store/hooks';
import { SET_NAV_OPEN } from '@store/app/app.reducer';

/**
 * Application frame, as in the legacy app: the page fills the window and the
 * side menu is a drawer that slides in over it (every page header carries
 * the hamburger that opens it). There is no permanent sidebar.
 */
const AppShell = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  // Route changes close the drawer.
  useEffect(() => {
    dispatch(SET_NAV_OPEN(false));
  }, [location.pathname, dispatch]);

  return (
    <div className='rep:relative rep:h-full rep:w-full rep:overflow-hidden rep:bg-background'>
      <SideMenu />
      <main className='rep:relative rep:h-full rep:w-full rep:overflow-hidden'>{children}</main>
    </div>
  );
};

export default AppShell;
